import React, { Component } from 'react';
import { Field } from 'redux-form';
import * as Form from './formFieldHelpers';
import { Buttons } from '../ui';

export default class HeadlineForm extends Component {
    componentDidMount () {
        this.handleInitialise();
    }

    handleInitialise = () => {
        const { initialize, body, personId } = this.props,
            initialValues = {
                "type": body ? "UPDATE" : "CREATE",
                "headline": body && body,
                "personId": personId,
            };
        initialize( initialValues );
    }

    render() {
        const { buttonHandlers, body } = this.props, numberButtons = body && 3;
        return (
            <form className="form-standard-profile">
                    <Field
                        name="headline"
                        placeholder="Headline"
                        component={ Form.textField }
                    />
                <Buttons.HOCFormButtons numberButtons={ numberButtons } { ... buttonHandlers } { ...this.props } />
            </form>
        )
    }
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/forms/HeadlineForm.js